import { EvtHeader } from "components/header";
import React from "react";
import { useParams } from "react-router-dom";
import DepartmentForm from "../form";

const UpdateDepartment = () => {
  const { departmentId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Department" />
      <div className="p-6 max-w-2xl">
        <DepartmentForm departmentId={departmentId} />
      </div>
    </div>
  );
};

export default UpdateDepartment;
